import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';
import { AuthPage } from '../../components/Auth/AuthPage';
import { ResetPassword } from '../../components/Auth/ResetPassword';
import { STORE_AUTH } from '../../constants';
import { AuthStore } from '../../stores';
import './style.css';

export interface ResetPasswordPageProps
  extends RouteComponentProps<{ token: string }> {
  /* [STORE_AUTH]: AuthStore; */
}

export interface ResetPasswordPageState {
  /* empty */
}

@inject(STORE_AUTH)
@observer
export class ResetPasswordPage extends React.Component<
  ResetPasswordPageProps,
  ResetPasswordPageState
> {
  UNSAFE_componentWillMount() {
    const authStore = this.props[STORE_AUTH] as AuthStore;

    authStore.clearResetPasswordError();
  }

  render() {
    const authStore = this.props[STORE_AUTH] as AuthStore;
    const token = this.props.match.params.token;

    return (
      <AuthPage loading={authStore.resetPasswordInProgress}>
        <ResetPassword
          error={authStore.resetPasswordError}
          loading={authStore.resetPasswordInProgress}
          onResetPassword={(email: string, password: string) =>
            authStore.resetPassword(token, email, password)
          }
        />
      </AuthPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/ResetPasswordPage/index.tsx